import RecurrentPaymentsTable from "./components/RecurrentPaymentsTable";

export default function RecurrentPaymentsScreen(): JSX.Element {
  return <RecurrentPaymentsTable />;
}
